import { TRACKING_ID_IN_PATH_METHODS, } from '../commerce-metadata.js';
export const getRequestOptions = (req, path) => {
    return {
        ...baseRequest(req, path),
        requestParams: prepareRequestParams(req),
    };
};
const prepareRequestParams = (req) => {
    const { trackingId, clientId, context, language, country, currency, page, perPage, facets, sort, } = req;
    return {
        trackingId,
        clientId,
        context,
        language,
        country,
        currency,
        page,
        perPage,
        facets,
        sort,
    };
};
export const baseRequest = (req, path) => {
    const { url, trackingId, accessToken } = req;
    const baseUrl = buildUrlWithTrackingIdInPath(url, trackingId, path);
    return {
        accessToken,
        method: 'POST',
        contentType: 'application/json',
        url: baseUrl,
        origin: 'commerceApiFetch',
        requestMetadata: { method: path },
    };
};
/**
 * Builds a URL to include the tracking ID in the path.
 * Used by endpoints that require tracking ID in the URL path instead of request body.
 **/
const buildUrlWithTrackingIdInPath = (baseUrl, trackingId, path) => {
    if (trackingId && TRACKING_ID_IN_PATH_METHODS.includes(path)) {
        return `${baseUrl}/tracking-ids/${trackingId}/${path}`;
    }
    return `${baseUrl}/${path}`;
};
